import { render, staticRenderFns } from "./QuizUnCommitted.vue?vue&type=template&id=4f995f81&scoped=true"
import script from "./QuizUnCommitted.vue?vue&type=script&lang=js"
export * from "./QuizUnCommitted.vue?vue&type=script&lang=js"
import style0 from "./QuizUnCommitted.vue?vue&type=style&index=0&id=4f995f81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f995f81",
  null
  
)

export default component.exports